// extracted by mini-css-extract-plugin
export default {"close":"closeButton_close__QD3gT","mobile":"closeButton_mobile__9rWHI"};